import { useQuery } from '@tanstack/react-query';

import { users } from '../../api';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

export const useGetUser = ({ slug }) => {
    const { t } = useTranslation();
    const history = useHistory();

    return useQuery(['user', slug], () => users.getUser(slug), {
        enabled: !!slug,
        onError: (error) => {
            if (error.response?.status === 404) {
                toast.error(t('User not found'));
                history.push('/chain/users');
            } else {
                toast.error(error.response?.data?.message);
            }
        },
    });
};
